export const messages = {
  en: {
    maintainanceTaskManage: {
      searchTitle: 'Search Conditions',
      listTitle: 'Maintenance Tasks',
      planUserNamePlaceholder: 'Please enter executor',
      startTimePlaceholder: 'Please enter actual maintenance start time',
      endTimePlaceholder: 'Please enter actual maintenance end time',
      planNamePlaceholder: 'Please enter maintenance plan name',
      statePlaceholder: 'Please select maintenance status',
      search: 'Search',
      reset: 'Reset',
      taskId: 'Task Code',
      planName: 'Maintenance Plan',
      timeRange: 'Start/End Time',
      actInsTime: 'Actual Maintenance Time',
      originalPlanUser: 'Planned Maintainer',
      currentPlanUser: 'Current Maintainer',
      transferDesc: 'Transfer Description',
      state: 'Maintenance Status',
      operation: 'Operation',
      transfer: 'Transfer',
      detail: 'Detail',
      delete: 'Delete',
      tip: 'Maintenance tasks are automatically generated based on maintenance plans. If not generated, please confirm whether the scheduled task is enabled (and wait about 30 minutes) or whether the maintenance plan is set correctly',
      fetchError: 'Failed to get maintenance tasks'
    },
    maintainanceTaskTransfer: {
      title: 'Transfer',
      transferTarget: 'Transfer Target',
      transferDesc: 'Transfer Description',
      transferDescPlaceholder: 'Required, please fill in the transfer description',
      staffRequired: 'Please select staff',
      descRequired: 'Description cannot be empty',
      descMaxLength: 'Description is too long',
      sameUserError: 'Cannot transfer to current maintainer',
      cancel: 'Cancel',
      submit: 'Submit',
      success: 'Transfer successful',
      error: 'Transfer failed'
    },
    maintainanceTaskDetail: {
      title: 'Task Details',
      machineName: 'Equipment Name',
      standardName: 'Maintenance Standard',
      planUserName: 'Planned Maintainer',
      actUserName: 'Actual Maintainer',
      stateName: 'Task Status',
      description: 'Maintenance Situation',
      photos: 'Maintenance Photos',
      createTime: 'Create Time',
      viewDetail: 'View Details',
      fetchError: 'Failed to get task details',
      timeRange: 'Start/End Time',
      actInsTime: 'Actual Maintenance Time',
      planName: 'Maintenance Plan',
    },
    deleteMaintainanceTask: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this maintenance task?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      success: 'Delete successful',
      error: 'Delete failed'
    },
    chooseOrgTree2: {
      placeholder: 'Required, please select related organization',
      title: 'Select Organization',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    staffSelect2: {
      placeholder: 'Required, please select staff'
    },
    viewMap: {
      noLocation: 'No location information available'
    },
    viewImage: {
      noImage: 'No image available',
      loadError: 'Image load failed'
    }
  },
  zh: {
    maintainanceTaskManage: {
      searchTitle: '查询条件',
      listTitle: '保养任务',
      planUserNamePlaceholder: '请输入执行人',
      startTimePlaceholder: '请输入实际保养开始时间',
      endTimePlaceholder: '请输入实际保养结束时间',
      planNamePlaceholder: '请输入保养计划名称',
      statePlaceholder: '请选择保养状态',
      search: '查询',
      reset: '重置',
      taskId: '任务编码',
      planName: '保养计划',
      timeRange: '开始/结束时间',
      actInsTime: '实际保养时间',
      originalPlanUser: '计划保养人',
      currentPlanUser: '当前保养人',
      transferDesc: '转移描述',
      state: '保养状态',
      operation: '操作',
      transfer: '流转',
      detail: '详情',
      delete: '删除',
      tip: '保养任务是根据保养计划，自动生成，如果没有生成 请确认是否开启了定时任务(并等待30分钟左右)，或者保养计划是否设置正确',
      fetchError: '获取保养任务失败'
    },
    maintainanceTaskTransfer: {
      title: '流转',
      transferTarget: '流转对象',
      transferDesc: '流转说明',
      transferDescPlaceholder: '必填，请填写转赠说明',
      staffRequired: '请选择员工',
      descRequired: '说明不能为空',
      descMaxLength: '说明太长',
      sameUserError: '不能流转给当前保养人',
      cancel: '取消',
      submit: '提交',
      success: '流转成功',
      error: '流转失败'
    },
    maintainanceTaskDetail: {
      title: '任务详情',
      machineName: '设备名称',
      standardName: '保养标准',
      planUserName: '计划保养人',
      actUserName: '实际保养人',
      stateName: '任务状态',
      description: '保养情况',
      photos: '保养照片',
      createTime: '创建时间',
      viewDetail: '详情',
      fetchError: '获取任务详情失败',
      timeRange: '开始/结束时间',
      actInsTime: '实际保养时间',
      planName: '保养计划',
    },
    deleteMaintainanceTask: {
      title: '请确认您的操作',
      confirmText: '确定删除保养任务？',
      cancel: '点错了',
      confirm: '确认删除',
      success: '删除成功',
      error: '删除失败'
    },
    chooseOrgTree2: {
      placeholder: '必填，请填写关联组织',
      title: '选择组织',
      cancel: '取消',
      confirm: '确定'
    },
    staffSelect2: {
      placeholder: '必填，请选择员工'
    },
    viewMap: {
      noLocation: '暂无位置信息'
    },
    viewImage: {
noImage: '暂无图片',
      loadError: '图片加载失败'
    }
  },
  'zh-TW': {
    maintainanceTaskManage: {
      searchTitle: '查詢條件',
      listTitle: '保養任務',
      planUserNamePlaceholder: '請輸入執行人',
      startTimePlaceholder: '請輸入實際保養開始時間',
      endTimePlaceholder: '請輸入實際保養結束時間',
      planNamePlaceholder: '請輸入保養計劃名稱',
      statePlaceholder: '請選擇保養狀態',
      search: '查詢',
      reset: '重設',
      taskId: '任務編號',
      planName: '保養計劃',
      timeRange: '開始/結束時間',
      actInsTime: '實際保養時間',
      originalPlanUser: '計劃保養人',
      currentPlanUser: '當前保養人',
      transferDesc: '轉移描述',
      state: '保養狀態',
      operation: '操作',
      transfer: '流轉',
      detail: '詳情',
      delete: '刪除',
      tip: '保養任務是根據保養計劃，自動生成，如果沒有生成 請確認是否開啟了定時任務(並等待30分鐘左右)，或者保養計劃是否設置正確',
      fetchError: '獲取保養任務失敗'
    },
    maintainanceTaskTransfer: {
      title: '流轉',
      transferTarget: '流轉對象',
      transferDesc: '流轉說明',
      transferDescPlaceholder: '必填，請填寫轉贈說明',
      staffRequired: '請選擇員工',
      descRequired: '說明不能為空',
      descMaxLength: '說明太長',
      sameUserError: '不能流轉給當前保養人',
      cancel: '取消',
      submit: '提交',
      success: '流轉成功',
      error: '流轉失敗'
    },
    maintainanceTaskDetail: {
      title: '任務詳情',
      machineName: '設備名稱',
      standardName: '保養標準',
      planUserName: '計劃保養人',
      actUserName: '實際保養人',
      stateName: '任務狀態',
      description: '保養情況',
      photos: '保養照片',
      createTime: '創建時間',
      viewDetail: '詳情',
      fetchError: '獲取任務詳情失敗',
      timeRange: '開始/結束時間',
      actInsTime: '實際保養時間',
      planName: '保養計劃',
    },
    deleteMaintainanceTask: {
      title: '確認操作',
      confirmText: '確定刪除保養任務？',
      cancel: '點錯了',
      confirm: '確認刪除',
      success: '刪除成功',
      error: '刪除失敗'
    },
    chooseOrgTree2: {
      placeholder: '必填，請填寫關聯組織',
      title: '選擇組織',
      cancel: '取消',
      confirm: '確定'
    },
    staffSelect2: {
      placeholder: '必填，請選擇員工'
    },
    viewMap: {
      noLocation: '暫無位置信息'
    },
    viewImage: {
      noImage: '暫無圖片',
      loadError: '圖片加載失敗'
    }
  }
}